import React, { useEffect, useState, useRef } from "react";
import "./css/countryaboutussection.css";
const badge_img = require("../../assets/aboutexplore/Rectangle 113.png");
const canada_bg_img = require("../../assets/countrywiseimages/canada.jpg");
const germany_bg_img = require("../../assets/countrywiseimages/germany.jpg");
const usa_bg_img = require("../../assets/countrywiseimages/usa.jpg");
const uk_bg_img = require("../../assets/countrywiseimages/uk.jpg");
const dubai_bg_img = require("../../assets/countrywiseimages/dubai.jpg");
const australia_bg_img = require("../../assets/countrywiseimages/australia.jpg");
const countriesInfo = [
  {
    countryImg: germany_bg_img,
    countryName: "GERMANY",
    countryTitle: "Germany",
    countryInfo1: ` Germany is the world’s leading innovation hub and boasts strong and stable indicators in economy, healthcare, natural resources, education, and EU-NATO membership. `,
    countryInfo2: `Germany is ranked among the world's top destinations for international students and offers 100% scholarships in form of aid and grants. Other administration and other costs can be covered with a small fee.   `,
  },
  {
    countryImg: usa_bg_img,
    countryName: "U.S.A.",
    countryTitle: "United States America",
    countryInfo1: `The US boasts the finest universities that have consistently ranked in the world university rankings, have high academic standards, follow rigorous practices to maintain quality, and are well-supported to offer excellent education.  `,
    countryInfo2: `<p style="font-weight: 400;">&nbsp;Why America is the best country to study?</p>
    <ul style="font-weight: 400;">
    <li>Unbeatable choices.</li>
    <li>High standard of education.</li>
    <li>Scholarship opportunities.</li>
    <li>Working in the US.&nbsp;</li>
    </ul>`,
  },
  {
    countryImg: uk_bg_img,
    countryName: "UNITED KINGDOM",
    countryTitle: "United Kingdom",
    countryInfo1: `Universities in the UK have the best academic standards in the world. Four out of the top 10 universities in the world are from the UK including the likes of Oxford and Cambridge. `,
    countryInfo2: `Institutions consistently perform well in rankings, hold a reputation for high-quality education and world-leading research, develop the study skills, academic knowledge, and English language skills, and education is recognized internationally.  `,
  },
  {
    countryImg: canada_bg_img,
    countryName: "CANADA",
    countryTitle: "Canada",
    countryInfo1: ` Canada is an attractive option for its courses and post-study work options which can pave the way to a Canada PR visa. Canada offers a Post-graduate work permit or PGWP to international students. `,
    countryInfo2: ` Low crime rates, great student health benefits, and universities focused on student security and health make studying in Canada a good choice for anyone who's uneasy about personal safety while abroad. `,
  },
  {
    countryImg: dubai_bg_img,
    countryName: "U.A.E",
    countryTitle: "U.A.E",
    countryInfo1: `UAE's best educational institutions are situated in Abu Dhabi and Dubai. Both cities are truly cosmopolitan and help UAE attain the tag of the fastest-growing economy in the world and hence offer a plethora of opportunities for career growth.`,
    countryInfo2: ` UAE encourages well-established universities like Heriot-Watt University, BITS Pilani, and the University of Wollongong to set up campuses in Dubai. The enrolled student receives an internationally recognized diploma with the language of instruction in English.  `,
  },
  {
    countryImg: australia_bg_img,
    countryName: "AUSTRALIA",
    countryTitle: "Australia",
    countryInfo1: `Australian universities provide great scholarship opportunities both for international students to reduce or completely cover their tuition fees.  `,
    countryInfo2: ` Standing tall with 7 of the top 100 universities in the world Indian students are opting to study abroad for its world-class education, post-study work opportunities, and excellent quality of living.  `,
  },
];

function CountryAboutUsSection(props) {
  const [selectedCountryInfo, setSelectedCountryInfo] = useState({
    countryImg: germany_bg_img,
    countryName: "GERMANY",
    countryTitle: "Germany",
    countryInfo1:
      "Located in Northwestern Europe, the Germany is a charming country with a long and rich history in culture.",
    countryInfo2:
      "The country stretches over 242,495 km sq. with a population exceeding 63 million.",
    countryInfo3:
      "In addition, The UK boasts world’s best universities and institutions. The country offers the best environment to study which pushes students to break the boundaries and understand various perspectives.",
    countryInfo4:
      "Moreover, the UK offers thousands of courses to choose from which gives students a wide variety of choices.",
  });

  useEffect(() => {
    if (props.selectedTab) {
      const countryInfo = countriesInfo.findIndex((info) => {
        return info.countryName === props.selectedTab;
      });

      setSelectedCountryInfo(countriesInfo[countryInfo]);
    }
  }, [props.selectedTab]);
  return (
    <section
      className="country_about_us_main_container"
      style={{
        backgroundImage: `url(${selectedCountryInfo.countryImg})`,
      }}
    >
      <div className="country_about_under_container">
        <div className="country_two_container">
          <div className="country_first_about_us_container">
            <p className="about_country_us_text">About</p>
            <p className="about_country_name_text">
              {selectedCountryInfo.countryTitle}
            </p>
          </div>
          <div className="country_sec_about_us_container">
            <div
              className="country_about_us_box_container wow bounceInRight"
              data-wow-duration="2s"
              data-wow-delay="1s"
            >
              <img
                src={badge_img}
                alt="badge_img"
                className="badge_box_img_self"
              />
              <div className="content_between_img_container" />
              <div
                className="all_content_container_scroll"
                dangerouslySetInnerHTML={{
                  __html: selectedCountryInfo.countryInfo1,
                }}
              ></div>
            </div>
            <div
              className="country_about_us_box1_container wow bounceInLeft"
              data-wow-duration="2s"
              data-wow-delay="0.5s"
            >
              <img
                src={badge_img}
                alt="badge_img"
                className="badge_box_img_self"
              />
              <div className="content_between_img_container" />
              <div
                className="all_content_container_scroll"
                dangerouslySetInnerHTML={{
                  __html: selectedCountryInfo.countryInfo2,
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CountryAboutUsSection;
